export const FORM_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const MIN_LOG_INTERVAL_MINUTES = 60;
export const TIME_PICKER_INTERVAL_MINUTES = 1;
export const CLOCK_IN_MIN_DATE_BACKOFF_AMOUNT_DAYS = 13;
